import { computed, ref, watch } from 'vue';

// Paginación local de los registros recibidos; el total no representa
// registros que el endpoint no haya entregado.
export function useListPage(rows, pageSize = 10) {
  const page = ref(1);
  const totalPages = computed(() => Math.max(1, Math.ceil(rows.value.length / pageSize)));
  watch(totalPages, (total) => { page.value = Math.min(page.value, total); }, { flush: 'sync' });
  const visible = computed(() => rows.value.slice((page.value - 1) * pageSize, page.value * pageSize));
  return { page, visible, pageSize };
}
